import uniqBy from 'lodash.uniqby';

import CART_ITEM from '../../constants/cartItems';

/**
 * Determines if all cart items belong to a single vendor or multiple.
 * Note that an undefined vendor might mean users are combining Waldo items (Waldograms) + vendor items.
 *
 * @param {Array<Object>} cart The cart items.
 * @returns {boolean} Whether or not all items belong to a single vendor.
 */
export const containSingleVendorItems = cart => {
  const filteredCart = cart.filter(
    item => item.type !== CART_ITEM.PRINT_ORDER_SERVICE,
  );

  const [item] = filteredCart;

  return !filteredCart.find(
    cartItem => cartItem.vendor?.id !== item?.vendor?.id,
  );
};

/**
 * Determines if all cart items belong to a single event
 * Note that an undefined vendor might mean users are combining Waldo items (Waldograms) + vendor items.
 *
 * @param {Array<Object>} cart The cart items.
 * @returns {boolean} Whether or not all items belong to a single event
 */
export const containSingleEventItems = cart => {
  const filteredCart = cart.filter(
    item => item.type !== CART_ITEM.PRINT_ORDER_SERVICE,
  );

  const [item] = filteredCart;

  return !filteredCart.find(
    cartItem =>
      cartItem.albumMembershipGroup?.id !== item?.albumMembershipGroup?.id,
  );
};

export const containsTransactionsMissingPrepaidItems = (
  cart,
  prepaidPrintPackagesMissingConfiguration,
  prepaidPhotoPricingsMissingConfiguration,
  prepaidCustomPrintsMissingConfiguration,
) => {
  if (
    !cart.length ||
    (!prepaidPrintPackagesMissingConfiguration.length &&
      !prepaidPhotoPricingsMissingConfiguration.length &&
      !prepaidCustomPrintsMissingConfiguration.length)
  ) {
    return false;
  }

  let transactionMissingPrepaidItemsFound = false;
  const transactionIdsMissingConfiguration = uniqBy(
    [
      ...prepaidPrintPackagesMissingConfiguration,
      ...prepaidPhotoPricingsMissingConfiguration,
      ...prepaidCustomPrintsMissingConfiguration,
    ]
      .map(({ transaction }) => transaction.id)
      .filter(Boolean),
  );

  cart.forEach(item => {
    if (transactionMissingPrepaidItemsFound) {
      return;
    }

    if (
      !item.purchasedPrintPackage &&
      !item.purchasedPhotoPricing &&
      !item.purchasedCustomPrint
    ) {
      return;
    }

    const transactionId =
      item.purchasedPrintPackage?.transaction?.id ??
      item.purchasedPhotoPricing?.transaction?.id ??
      item.purchasedCustomPrint?.transaction?.id;

    if (!transactionId) {
      return;
    }

    if (transactionIdsMissingConfiguration.includes(transactionId)) {
      transactionMissingPrepaidItemsFound = true;
    }
  });

  return transactionMissingPrepaidItemsFound;
};
